import { LocationFlagReason, ReviewErrorTypeEnum, SelectableBranchRole, SelectableLocationRole, SelectableSystemRole } from './types';

export const possibleSystemRoles: SelectableSystemRole[] = [
  { name: 'Admin', id: 'admin' },
  { name: 'Investigator', id: 'investigator' },
  { name: 'Validator', id: 'validator' },
];

export const possibleBranchRoles: SelectableBranchRole[] = [
  { name: 'Branch Owner', id: 'branch-owner' },
  { name: 'Branch Manager', id: 'branch-manager' },
  { name: 'Market Manager', id: 'market-manager' },
  { name: 'Installer', id: 'installer' },
  { name: 'Self-service', id: 'self-service' },
  { name: 'Self-service (Investigator)', id: 'self-service-investigator' },
];

export const possibleLocationRoles: SelectableLocationRole[] = [
  { name: 'Guest', id: 'guest' },
  { name: 'Location Manager', id: 'location-manager' },
  { name: 'Market Health Manager', id: 'market-health-manager' },
];

export const availablePlatforms = [
  'adm',
  'smarthq',
  'avanti',
  'avantiazure',
  'companykitchen',
  'averigo',
  'vendorexchange_api',
  'vendorexchange',
  'avantiweb',
];

export const LOCATION_FLAG_REASONS: LocationFlagReason[] = [
  {
    id: ReviewErrorTypeEnum.CamerasOffline,
    description: 'All available cameras are offline',
  },
  {
    id: ReviewErrorTypeEnum.CamerasLowBandwidth,
    description: 'There are problems with the camera bandwidth',
  },
  {
    id: ReviewErrorTypeEnum.CamerasBadAngle,
    description: 'All available cameras have no good view of the market',
  },
  {
    id: ReviewErrorTypeEnum.MarketReportNoAccess,
    description: 'No access to market reports',
  },
  {
    id: ReviewErrorTypeEnum.MarketReportMissingTransactions,
    description: 'There are missing transactions in the market report',
  },
];

export const APPLICATION_TIMEZONES = [
  // US
  'US/Pacific',
  'US/Eastern',
  'US/Mountain',
  'US/Central',
  'US/Alaska',
  'America/New_York',
  'America/Detroit',
  'America/Kentucky/Louisville',
  'America/Kentucky/Monticello',
  'America/Indiana/Indianapolis',
  'America/Indiana/Vincennes',
  'America/Indiana/Winamac',
  'America/Indiana/Marengo',
  'America/Indiana/Vevay',
  'America/Chicago',
  'America/Indiana/Tell_City',
  'America/Indiana/Knox',
  'America/North_Dakota/Center',
  'America/North_Dakota/New_Salem',
  'America/North_Dakota/Beulah',
  'America/Denver',
  'America/Phoenix',
  'America/Los_Angeles',
  'America/Boise',
  // Alaska
  'America/Anchorage',
  'America/Adak',
  'America/Juneau',
  'America/Metlakatla',
  'America/Nome',
  'America/Sitka',
  // Hawaii
  'Pacific/Honolulu',
  // Canada
  'America/St_Johns',
  'America/Halifax',
  'America/Glace_Bay',
  'America/Goose_Bay',
  'America/Moncton',
  'America/Blanc-Sablon',
  'America/Montreal',
  'America/Toronto',
  'America/Iqaluit',
  'America/Pangnirtung',
  'America/Coral_Harbour',
  'America/Winnipeg',
  'America/Resolute',
  'America/Rankin_Inlet',
  'America/Rainy_River',
  'America/Nipigon',
  'America/Thunder_Bay',
  'America/Atikokan',
  'America/Edmonton',
  'America/Cambridge_Bay',
  'America/Yellowknife',
  'America/Inuvik',
  'America/Swift_Current',
  'America/Regina',
  'America/Vancouver',
  'America/Whitehorse',
  'America/Dawson',
  'America/Dawson_Creek',
  'America/Creston',
  'America/Fort_Nelson',
];
